/* Alignora — theme behavior */
/* Sticky add-to-cart on mobile, scroll-triggered reveals,
 * gallery crossfade, header shadow on scroll, and small touches that play
 * nicely with Dawn's existing scripts. */

document.documentElement.classList.add('js');

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ----- Sticky add-to-cart slide-up reveal -----------------------
  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) return;
    var mainForm = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!mainForm) return;
    var anchor = mainForm.querySelector('button[type="submit"], [name="add"]');
    if (!anchor) return;

    var anchorTop = anchor.getBoundingClientRect().top + window.scrollY;
    function update() {
      if (window.innerWidth > 768) { sticky.classList.remove('is-visible'); return; }
      sticky.classList.toggle('is-visible', window.scrollY > anchorTop + 60);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
      anchorTop = anchor.getBoundingClientRect().top + window.scrollY;
      update();
    });
    update();
  }

  // ----- Sticky variant id sync -----------------------------------
  function initStickyVariantSync() {
    var hidden = document.querySelector('[data-sticky-variant-input]');
    if (!hidden) return;
    document.addEventListener('change', function () {
      var variantInput = document.querySelector('product-form form [name="id"]:not([data-sticky-variant-input])');
      if (variantInput && variantInput.value) hidden.value = variantInput.value;
    });
    var priceEl = document.querySelector('[data-sticky-atc-price]');
    if (!priceEl) return;
    document.addEventListener('variant:change', function (e) {
      if (e && e.detail && e.detail.variant && e.detail.variant.price) {
        priceEl.textContent = (e.detail.variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      }
    });
  }

  // ----- Scroll-triggered reveal ----------------------------------
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ----- Header scroll shadow -------------------------------------
  function initHeaderShadow() {
    var header = document.querySelector('.header-wrapper, .alignora-header');
    if (!header) return;
    var update = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ----- CTA arrow nudge ------------------------------------------
  function initArrowNudge() {
    document.querySelectorAll('.alignora-btn').forEach(function (btn) {
      if (btn.dataset.arrowWrapped) return;
      var html = btn.innerHTML.replace(/\s*→\s*$/, '');
      if (html !== btn.innerHTML) {
        btn.innerHTML = html + ' <span class="alignora-btn-arrow" aria-hidden="true">→</span>';
        btn.dataset.arrowWrapped = '1';
      }
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    initStickyAtc();
    initStickyVariantSync();
    initReveal();
    initHeaderShadow();
    initArrowNudge();
  });
})();
